import { render, staticRenderFns } from "./ModalDespesasFixas.vue?vue&type=template&id=2f324d64&"
import script from "./ModalDespesasFixas.vue?vue&type=script&lang=js&"
export * from "./ModalDespesasFixas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports